import React from 'react';
import { StatusWrapper } from './Styled';
import { color } from '../../styles';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';

interface StatusProps {
    colorTheme: ColorTheme;
    text?: string;
    width?: string;
    icon?: React.ReactNode;
    onClick?: () => void;
}

export type ColorTheme =
    | 'SUCCESS'
    | 'FAIL'
    | 'WARNING'
    | 'WARNING_LIGHT'
    | 'INFO'
    | 'PENDING'
    | 'WAREHOUSE'
    | 'DISABLE';

const statusColorTheme = {
    SUCCESS: {
        color: color.status.SUCCESS,
        backgroundColor: color.status.SUCCESS_LIGHT,
    },
    FAIL: {
        color: color.status.FAIL,
        backgroundColor: color.status.DANGER_LIGHT,
    },
    WARNING: {
        color: color.status.WARNING,
        backgroundColor: color.status.WARNING_LIGHT,
    },
    WARNING_LIGHT: {
        color: color.status.WARNING_LIGHT,
        backgroundColor: color.status.WARNING_LIGHT,
    },
    INFO: {
        color: color.status.INFORMATION,
        backgroundColor: color.status.INFO_LIGHT,
    },
    PENDING: {
        color: 'white',
        backgroundColor: color.status.WARNING,
    },
    WAREHOUSE: {
        color: color.status.WAREHOUSE,
        backgroundColor: color.status.WAREHOUSE_LIGHT,
    },
    DISABLE: {
        color: color.secondary.DARK_GREY,
        backgroundColor: '#F2F4FA',
    },
};

const Status = ({ colorTheme, text, width, onClick, icon }: StatusProps) => {
    const colorThemeObject = statusColorTheme[colorTheme] || statusColorTheme.INFO;

    return (
        <StatusWrapper
            $color={colorThemeObject.color}
            $backgroundColor={colorThemeObject.backgroundColor}
            $width={width}
            onClick={onClick}
        >
            {text} {onClick && <FeedbackOutlinedIcon />}
            {icon ? icon : null}
        </StatusWrapper>
    );
};

export default Status;
